import { IconFont } from '@/components/IconFont'
import { projectContext } from '@/layouts/MainLayout'
import { deleteProjectRole, getProjectRoles } from '@/services/role/role'
import { ProjectRole } from '@/services/role/role.model'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button, Card, Modal, Space, Table } from 'antd'
import React, { memo, useContext } from 'react'
import AddEditRoleModal from './AddEditRole'

const { Column } = Table

export default memo(function ProjectSettingRole() {
  const { projectId, projectType } = useContext(projectContext)
  const { data: roles = [], loading, refresh } = useRequest(() => getProjectRoles(projectType, projectId))

  return (
    <Card
      title='Roles'
      extra={
        <Button
          icon={<IconFont type='icon-add' />}
          onClick={() => {
            AddEditRoleModal.show({
              title: 'Create Role',
              projectId,
              projectType,
              onSuccess: () => {
                refresh()
              }
            })
          }}
        />
      }
    >
      <Table
        pagination={{ pageSize: 30 }}
        size='small'
        loading={loading}
        dataSource={roles}
        rowKey={(record) => record.id}
      >
        <Column title='Index' align={'center'} render={(_, _record, index) => index + 1} />

        <Column title='Name' dataIndex='name' align={'center'} />

        <Column title='Permission' dataIndex='permission' align={'center'} />

        <Column
          title='operation'
          align={'center'}
          render={(_, record: ProjectRole) => (
            <Space>
              <IconFont
                type='icon-filter'
                onClick={() => {
                  AddEditRoleModal.show({
                    title: 'Edit Role',
                    projectId,
                    projectType,
                    role: record,
                    onSuccess: () => {
                      refresh()
                    }
                  })
                }}
              />

              <IconFont
                type='icon-shanchu'
                onClick={() => {
                  Modal.confirm({
                    icon: <ExclamationCircleOutlined />,
                    content: 'Are you sure to delete?',
                    onOk: async () => {
                      await deleteProjectRole(projectType, projectId, record.id)
                      refresh()
                    }
                  })
                }}
              />
            </Space>
          )}
        />
      </Table>
    </Card>
  )
})
